import React__default from 'react';

/**
 * When multiple nested date picker dropdowns are open, pressing "escape" should close only the top popover.
 * The parent popover needs to know which other popovers are open so we can stop "escape" closing the entire picker.
 */
var DatePickerDropdownContext = React__default.createContext({});
var useDatePickerDropdown = function () {
    var context = React__default.useContext(DatePickerDropdownContext);
    if (!context) {
        return {
            visiblePicker: null,
            setVisiblePicker: function () {
                // Do nothing
            },
        };
    }
    return context;
};

export { DatePickerDropdownContext as D, useDatePickerDropdown as u };
